export default __webpack_public_path__ + "static/media/famPic.9a92e85f.jpg";